import React, { useMemo, useState } from 'react';
import { DownloadIcon, SearchIcon } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
import { treatments } from '../data/treatments';
import { clinic } from '../data/clinic';

/** "Nazorg informatie" — the leaflet downloads from the current Patiënten informatie page. */
export function PatientInfo() {
  const [query, setQuery] = useState('');
  const leaflets = useMemo(() => {
    const q = query.trim().toLowerCase();
    return treatments.filter(t => t.pdf && (!q || t.name.toLowerCase().includes(q)));
  }, [query]);
  return <>
      <PageHeader title="Nazorg informatie" crumbs={[{
      label: 'Patiënten'
    }, {
      label: 'Patiënteninformatie'
    }]} intro="Hier vindt u de patiëntenfolders van onze behandelingen. Lees de folder van uw behandeling goed door, zodat u weet hoe u zich voorbereidt en wat u na de behandeling kunt verwachten." data-id="element-636" data-mp="g15f3ho278rf" />

      <section className="mx-auto max-w-7xl px-5 py-16 lg:px-8 lg:py-20" data-id="element-637" data-mp="b0zl3uubha66">
        <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end" data-id="element-638" data-mp="1w4mm0i196p27">
          <p className="text-[15px] text-muted" aria-live="polite" data-id="element-639" data-mp="1r6uon8huaaqm">
            {leaflets.length} patiëntenfolders · PDF
          </p>
          <label className="relative block w-full md:w-80" data-id="element-640" data-mp="255kk6jp0g2cv">
            <span className="sr-only" data-id="element-641" data-mp="206hqtwie7kkq">Zoek een folder</span>
            <SearchIcon className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-muted" aria-hidden="true" data-id="element-642" data-mp="204wrltl4vdgj" />
            <input type="search" value={query} onChange={e => setQuery(e.target.value)} placeholder="Zoek een behandeling" className="w-full rounded-full border border-line bg-white py-3 pl-11 pr-4 text-[15px] text-ink placeholder:text-muted focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/20" data-id="element-643" data-mp="18gd6tyyjozk1" />
          </label>
        </div>

        {leaflets.length === 0 ? <p className="mt-8 rounded-2xl bg-surface p-10 text-center text-muted" data-id="element-644" data-mp="opzzubxkea5h">Geen folder gevonden voor “{query}”.</p> : <ul className="mt-8 grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-645" data-mp="2tsew108036z4">
            {leaflets.map(t => <li key={t.slug} data-id="element-646" data-mp="2ykybk2q90c6k">
                <a href={t.pdf} target="_blank" rel="noreferrer" className="group flex h-full items-center justify-between gap-4 rounded-2xl bg-surface px-5 py-4 transition-colors duration-150 hover:bg-primary hover:text-white" data-id="element-647" data-mp="2ylzz36ogar56">
                  <span className="text-[15px] font-medium text-ink group-hover:text-white" data-id="element-648" data-mp="2ftf8xx04z052">{t.name}</span>
                  <DownloadIcon className="h-4 w-4 shrink-0 text-primary group-hover:text-white" aria-hidden="true" data-id="element-649" data-mp="2jv0qhvnm82ll" />
                </a>
              </li>)}
          </ul>}

        <p className="mt-12 border-t border-line pt-8 text-[15px] text-muted" data-id="element-650" data-mp="3va5ynf6imtcl">
          Krijgt u na de behandeling klachten die u niet vertrouwt? Neem contact op via{' '}
          <a href={clinic.phoneHref} className="font-medium text-primary hover:underline" data-id="element-651" data-mp="1jm111ntx2rxs">
            {clinic.phone}
          </a>{' '}
          of met uw huisarts. Buiten kantooruren kunt u terecht bij de huisartsenpost.
        </p>
      </section>
    </>;
}